import {AbstractControl, ValidationErrors} from '@angular/forms';
import type {FormlyFieldConfig} from '@ngx-formly/core';
import {Subscription} from 'rxjs';

export function stripPhoneNumber(value: string): string {
  return String(value ?? '').replaceAll(/\D/g, '');
}

export function formatPhoneNumber(value: string): string {
  const digits = String(value ?? '')
    .replaceAll(/\D/g, '')
    .slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function PhoneNumberValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  const digits = String(control.value).replaceAll(/\D/g, '');
  return digits.length === 10 ? null : {'phone-number': true};
}

export function PhoneNumberValidatorMessage(): string {
  return 'Please enter a 10-digit phone number.';
}

export function phoneNumberOnInit(field: FormlyFieldConfig): void {
  const ctrl = field.formControl;
  if (ctrl.value) ctrl.setValue(formatPhoneNumber(ctrl.value), {emitEvent: false});
  const sub: Subscription = ctrl.valueChanges.subscribe(v => {
    const formatted = formatPhoneNumber(v ?? '');
    if (formatted !== v) ctrl.setValue(formatted, {emitEvent: false});
  });
  const existingOnDestroy = field.hooks?.onDestroy;
  field.hooks = {
    ...field.hooks,
    onDestroy(f: FormlyFieldConfig) {
      sub.unsubscribe();
      if (existingOnDestroy) existingOnDestroy(f);
    },
  };
}
